<template>
  <div class="FilterControl ">
    <h3 class="ml-3 pl-3 mt-3 mr-3 pr-3">{{ filter.label }}</h3>
    <b-button size="sm" class="FilterControl__back FilterControl__top mr-3 text-right" @click="$emit('close')">Terug</b-button>
    
    <SvgIcon icon="Delete-icon" v-if="!last" class="FilterControl__top mr-3" @click.native="$emit('remove', filter)" />

    <div class="mx-3 px-3 text-red" v-if="allOff">
      Er moet minstens 1 optie geselecteerd worden.
    </div>
    <ul class="m-0 p-0 pl-3 ml-3 list-unstyled">
      <li class="d-flex my-3 mr-3 align-items-center">
        <span class="mr-2 flex-grow-1">Alles</span>
        <ToggleSwitch class="m-0" v-model="all" />
      </li>

      <li 
        v-for="option in filter.items" 
        :key="option.id"
        class="d-flex my-3 mr-3 align-items-center">
        <span class="mr-2 flex-grow-1">{{ option.label }}</span>
        <ToggleSwitch class="m-0" v-model="option.active" />
      </li>
    </ul>
    <b-button size="sm" class="FilterControl__back FilterControl__bottom mr-3 mb-3 text-right" @click="$emit('close')">Terug</b-button>
  </div>
</template>

<script>

import ToggleSwitch from 'molecule/form/ToggleSwitch'
import SvgIcon from 'atom/SvgIcon'

export default {
  name: 'FilterControl',
  components: { ToggleSwitch, SvgIcon },
  props: {
    filter: {
      type: Object,
      required: true
    },
    last: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    all: {
      get() {
        return this.filter.items.every(option => option.active)
      },
      set(value) {
        this.filter.items.forEach(option => option.active = value)
      }
    },
    allOff() {
      return this.filter.items.every(option => option.active === false) 
    }
  }
}
</script>

<style lang="scss">
.FilterControl {
  width: 100%;
  background: white;
  overflow-y: scroll;
  user-select: none;
  position: relative;

  h3 {
    font-size: 1.15em;
    font-weight: 700;
    margin-bottom: 20px;
    padding-left: 0.75rem;
    line-height: 1.5;
  }

  &__back {
    cursor: pointer;

    &:hover {
      color: darken(#7a99ac, 20%)
    }
  }
  .SvgIcon {
    color: #CED0DA;
    cursor: pointer;

    &:hover {
      color: #e04e39
    }
  }
  &__top {
    position: absolute;
    top: 1.25em;
    right: 0;
  }
  &__bottom {
    position: relative;
    bottom: 0em;
    left: calc(100% - 44px - 1rem);
  }
}
</style>